import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { AddAmbarRequest } from '../models/request/ambar/AddAmbarRequest';
import { GetAmbarListPagingAndFilterRequest } from '../models/request/ambar/GetAmbarListPagingAndFilterRequest';
import { AmbarFindPriceRequest } from '../models/request/ambar/AmbarFindPriceRequest';
// import { GetAmbarListPagingAndFilterRequest } from '../models/request/ambar/GetAmbarListPagingAndFilterRequest';

export class AmbarService {
    static async getAmbarList(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - getAmbarList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Ambar/getAmbarList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportAmbarList(inputObj: GetAmbarListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportAmbarList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Ambar/exportAmbarList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    /** Üst bar ikonu: Uyumsoft'ta hataya düşmüş kayıt sayısı (07.10.2026). */
    static async getIrsaliyeErrorCount(): Promise<{ isSuccess: boolean, message?: string, data: number }> {
        try {
            const resp = await axios.post(Helpers.getEndpoint() + '/Ambar/GetIrsaliyeErrorCount', {});

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getAmbarListPagingAndFilter(inputObj: GetAmbarListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetAmbarListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Ambar/GetAmbarListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addAmbar(inputObj: AddAmbarRequest) {
        try {
            const formData = this.getFormData(inputObj);

            console.log('SERVICE CALL - AddAmbar', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Ambar/AddAmbar', formData);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteAmbar(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteAmbar', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Ambar/deleteAmbar', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getAmbarById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getAmbarById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Ambar/getAmbarById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    /**
     * Siparisin guncel surum isareti (#424). Siparis ekrani icinden sunucuya yazan bir islemden
     * (or. Fiyat Bul Kaydet) sonra saklanan surum bununla tazelenir; yoksa kullanicinin kendi
     * islemi sonrasi Kaydet "baskasi degistirdi" diye engellenir.
     */
    static async getKayitSurumu(_id: string): Promise<{ isSuccess: boolean, message?: string, data: string | null }> {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - GetKayitSurumu', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Ambar/GetKayitSurumu', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static getFormData(obj: any = {}, formData = new FormData(), key = '') {
        if (!([Array, File, Object].includes(obj.constructor))) {
            return formData;
        }

        // Handle File recursive
        if (obj instanceof File) {
            formData.append(key, obj);
            return formData;
        }

        for (const prop in obj) {
            // Validate value type
            if (obj[prop] && !([String, Number, Boolean, Array, Object, File].includes(obj[prop].constructor))) {
                continue;
            }

            // Set deep index of prop
            const deepKey = key ? key + `.${prop}` : prop;

            // Handle array
            if (Array.isArray(obj[prop])) {
                obj[prop].forEach((item: any, index: any) => {
                    this.getFormData(item, formData, `${deepKey}[${index}]`);
                })
                continue;
            }

            (typeof obj[prop] === 'object' && obj[prop] && obj[prop].constructor === Object)
                ? this.getFormData(obj[prop], formData, deepKey) // Handle object
                : formData.append(deepKey, [undefined, null].includes(obj[prop]) ? '' : obj[prop]) // Handle string, number, boolean
        }

        return formData;
    }

    static async addInvoiceFromAmbar(_ambarId: string, _isSale: boolean, _currencyTypeId: string, _invoiceId?: string, _ignoreWithholding?: boolean) {
        try {
            var inputObj = {
                ambarId: _ambarId,
                isSale: _isSale,
                currencyTypeId: _currencyTypeId,
                invoiceId: _invoiceId,
                ignoreWithholding: _ignoreWithholding
            };

            console.log('SERVICE CALL - addInvoiceFromAmbar', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Invoice/addInvoiceFromAmbar', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async ambarFindPrice(inputObj: AmbarFindPriceRequest) {
        try {
            console.log('SERVICE CALL - ambarFindPrice', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Ambar/ambarFindPrice', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

}